function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigit7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3.85625mm",
    height: "5.9225349mm",
    viewBox: "0 0 3.85625 5.9225349",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-47.022327,-96.620305)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 47.305916,97.689064 q -0.08984,-0.152344 -0.136719,-0.285156 -0.04687,-0.136719 -0.04687,-0.25 0,-0.191406 0.113281,-0.265625 0.117188,-0.07813 0.421875,-0.07813 0.0039,0 0.660157,0.01953 0.660156,0.01953 1.316406,0.01953 0.34375,0 0.582031,-0.03125 0.238281,-0.03125 0.425781,-0.09766 0.07422,0.117188 0.105469,0.21875 0.03125,0.09766 0.03125,0.199219 0,0.277344 -0.554687,1.199219 -0.550782,0.921875 -0.851563,1.527343 -0.417969,0.832036 -0.609375,1.390626 -0.191406,0.55469 -0.191406,0.92188 0,0.0156 0.0039,0.0742 0.0039,0.0547 0.0039,0.0937 -0.152343,0.0469 -0.269531,0.0703 -0.113281,0.0273 -0.179687,0.0273 -0.203125,0 -0.304688,-0.0977 -0.101562,-0.0937 -0.101562,-0.28125 0,-0.375 0.414062,-1.23828 0.414063,-0.867186 1.832031,-3.304686 -0.21875,-0.01953 -0.476562,-0.02734 -0.253906,-0.01172 -0.585938,-0.01172 -0.597656,0 -0.992187,0.05078 -0.390625,0.05078 -0.609375,0.15625 z",
    style: {
      fontSize: 8,
      fontFamily: "'Maiandra GD'",
      InkscapeFontSpecification: "'Maiandra GD, Normal'",
      stroke: "#000000",
      strokeWidth: 0.2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigit7);
export default __webpack_public_path__ + "static/media/digit-7.2e53826ed4353be14d849886cb15204e.svg";
export { ForwardRef as ReactComponent };